import { Action, LoggedDetailsType } from "./IsLoggedInterfaces";

const signedInObj = JSON.parse(localStorage.getItem("accountInfo")||"{}");

const loggedReducer = (
	state:LoggedDetailsType = signedInObj
		? signedInObj
		: {
				isUserLogged: false,
				accessToken: "",
		  },
	action:Action
) => {
	switch (action.type) {
		case "USER_AUTHENTICATED":
			const now = new Date().getTime();
			var info = {
				isUserLogged: action.payload.isUserLogged,
				accessToken: action.payload.accessToken,
				tokenType: action.payload.tokenType,
				refreshToken: action.payload.refreshToken,
				user: action.payload.user,
				loginTime: now,
			};
			localStorage.setItem("accountInfo", JSON.stringify(info));

			return {
				...action.payload,
				loginTime: now
			};

		case "RESET_USER":
			var resetInfo = {
				isUserLogged: false,
				accessToken: "",
			};
			localStorage.setItem("accountInfo", JSON.stringify(resetInfo));

			return resetInfo;

		default:
			return state;
	}
};

export default loggedReducer;
